
import { Link } from 'react-router-dom';
import Hero from './components/Hero';
import RoomTypes from './components/RoomTypes';
import Facilities from './components/Facilities';
import About from './components/About';
import Contact from './components/Contact';
import Location from './components/Location';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <RoomTypes />
      <Facilities />
      <About />
      <Contact />
      <Location />
    </div>
  );
}
